import { Injectable } from '@angular/core';
import { IFuelLevelMapper } from '../interfaces/fuel-level-mapper';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class FuelLevelService {
  constructor(public http: HttpClient) {}

  public getFuelLevels(): Promise<IFuelLevelMapper[]> {
    return this.http.get<IFuelLevelMapper[]>('api/fuel-level').toPromise();
  }
}
